import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { driverSchema } from '../schemas/driver.schema';

/**
 * Retrieves all of the Drivers assigned to given Driver Groups
 * @param includeGroupId Driver Group ID
 * Without param will return all of the drivers list
 * @returns Drivers belonging to given Driver Group
 */
export function getDriversList(this: unknown, includeGroupId?: number) {
  let params = '';
  if (typeof includeGroupId === 'number') {
    params = `?${new URLSearchParams([
      ['includeGroupId', String(includeGroupId)],
    ]).toString()}`;
  }
  const requestUrl = `${fleetEnvironment.resolve(this).driverListUrl}${params}`;

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(driverSchema),
        message: z.string().nullable(),
      })
    )
  );
}
